import { getAuthToken } from "@dynamic-labs/sdk-react-core";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { useEoa } from "#/store/wallet/eoa/eoa";

import { createApiKey } from "../kyan.service";
import { type CreateApiKeyResponse } from "../kyan.types";
import { defaultApiResponseHandler } from "../kyan.utils";

export const useCreateApiKey = (
  isFor1CT: boolean,
  options?: UseMutationOptions<CreateApiKeyResponse["data"] | undefined>,
) => {
  const { eoa } = useEoa();
  return useMutation({
    ...options,
    mutationFn: async () => {
      const token = getAuthToken();

      if (!token) {
        throw new Error("No auth token or wallet connected");
      }

      return defaultApiResponseHandler({
        serviceName: "Create Api Key",
        payload: { token, account: isFor1CT ? eoa : undefined },
        service: createApiKey,
      });
    },
  });
};
